module.exports = __webpack_public_path__ + "static/media/product-4.51b9ebcd.jpg";